module.exports = __webpack_public_path__ + "media/rl_sizzle_reel.d8548f23.mp4";